/* 4T5 MY GARAGE
   Saves the shopper's car in this browser and checks every product page against it.
   Fitment comes from the product's veh_chassis_* and ymm_year_* tags.
   To add a car: add a line to CARS (chassis = the veh_chassis_ tag value(s)). */
(function () {
  'use strict';

  var CARS = [
    { id: 'fl5',  label: 'Honda Civic Type R FL5',        short: 'FL5 Type R',   chassis: ['fl5'],         from: 2023, to: 2026, url: '/collections/fl5' },
    { id: 'fk8',  label: 'Honda Civic Type R FK8',        short: 'FK8 Type R',   chassis: ['fk8'],         from: 2017, to: 2021, url: '/collections/fk8' },
    { id: 'a90',  label: 'Toyota GR Supra (A90 / A91)',   short: 'GR Supra',     chassis: ['a90'],         from: 2020, to: 2026, url: '/collections/supra' },
    { id: 'zn8',  label: 'Toyota GR86 / Subaru BRZ (2022+)', short: 'GR86 / BRZ', chassis: ['zn8', 'zd8'], from: 2022, to: 2026, url: '/collections/gr86' },
    { id: 's650', label: 'Ford Mustang S650',             short: 'Mustang S650', chassis: ['s650'],        from: 2024, to: 2026, url: '/collections/s650' },
    { id: 's550', label: 'Ford Mustang S550',             short: 'Mustang S550', chassis: ['s550'],        from: 2015, to: 2023, url: '/collections/s550' },
    { id: 'c8',   label: 'Chevrolet Corvette C8',         short: 'Corvette C8',  chassis: ['c8'],          from: 2020, to: 2026, url: '/collections/c8-corvette' },
    { id: 'c7',   label: 'Chevrolet Corvette C7',         short: 'Corvette C7',  chassis: ['c7'],          from: 2014, to: 2019, url: '/collections/c7-corvette' },
    { id: 'c6',   label: 'Chevrolet Corvette C6',         short: 'Corvette C6',  chassis: ['c6'],          from: 2005, to: 2013, url: '/collections/c6-corvette' },
    { id: 'c5',   label: 'Chevrolet Corvette C5',         short: 'Corvette C5',  chassis: ['c5'],          from: 1997, to: 2004, url: '/collections/c5-corvette' },
    { id: 'cam6', label: 'Chevrolet Camaro 6th Gen',      short: '6th Gen Camaro', chassis: ['camaro_6th'], from: 2016, to: 2024, url: '/collections/6th-gen' },
    { id: 'cam5', label: 'Chevrolet Camaro 5th Gen',      short: '5th Gen Camaro', chassis: ['camaro_5th'], from: 2010, to: 2015, url: '/collections/5th-gen' }
  ];
  /* homepage Find Parts selector chassis -> garage car */
  var YMM_MAP = { fl5: 'fl5', fk8: 'fk8', a90: 'a90', zn8: 'zn8', s650: 's650', c8: 'c8', c7: 'c7', c6: 'c6', gen6: 'cam6', gen5: 'cam5' };
  var KEY = 't45_garage_v1';
  var EMAIL = 'Support@4thto5thautomotive.com';

  function carById(id) { for (var i = 0; i < CARS.length; i++) { if (CARS[i].id === id) return CARS[i]; } return null; }
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); if (v && carById(v.id)) return v; } catch (e) {}
    return null;
  }
  function save(id, year) {
    var v = { id: id, year: year ? parseInt(year, 10) : null };
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    render();
    return v;
  }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} render(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function carName(v) { var c = carById(v.id); return (v.year ? v.year + ' ' : '') + c.label; }

  /* ---------- fitment check ---------- */
  function fitFor(tags, v) {
    var chassis = [], years = [];
    tags.forEach(function (t) {
      var m;
      if (t.indexOf('veh_chassis_') === 0) chassis.push(t.slice(12));
      else if ((m = /^ymm_year_(\d{4})$/.exec(t))) years.push(parseInt(m[1], 10));
    });
    if (!chassis.length) return { state: 'unknown' };
    var car = carById(v.id), hit = false;
    car.chassis.forEach(function (c) { if (chassis.indexOf(c) > -1) hit = true; });
    var listed = [];
    CARS.forEach(function (c) {
      for (var i = 0; i < c.chassis.length; i++) { if (chassis.indexOf(c.chassis[i]) > -1) { listed.push(c.short); break; } }
    });
    if (!hit) return { state: 'no', listed: listed };
    if (v.year && years.length && years.indexOf(v.year) === -1) {
      years.sort(); return { state: 'year', range: years[0] + '&ndash;' + years[years.length - 1] };
    }
    return { state: 'yes' };
  }

  function renderFit() {
    var data = document.getElementById('t45-fit-data');
    if (!data) return;
    var tags; try { tags = JSON.parse(data.textContent); } catch (e) { return; }
    var box = document.getElementById('t45-fit');
    if (!box) {
      var title = document.querySelector('.product__title');
      if (!title) return;
      box = document.createElement('div');
      box.id = 't45-fit';
      title.parentNode.insertBefore(box, title.nextSibling);
    }
    var v = load(), html, cls;
    if (!v) {
      cls = 'ask';
      html = '<span class="t45-fit__icon">?</span><span><b>Will this fit your car?</b> <button type="button" class="t45-fit__link" data-garage-open>Add your car</button> and we&rsquo;ll check every part for you.</span>';
    } else {
      var f = fitFor(tags, v), car = carById(v.id);
      if (f.state === 'yes') { cls = 'yes'; html = '<span class="t45-fit__icon">&#10003;</span><span><b>Fits your ' + esc(carName(v)) + '</b></span>'; }
      else if (f.state === 'year') { cls = 'warn'; html = '<span class="t45-fit__icon">!</span><span><b>Check your year.</b> Listed for ' + esc(car.short) + ' ' + f.range + ', not ' + v.year + '. Email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> to confirm.</span>'; }
      else if (f.state === 'no') { cls = 'no'; html = '<span class="t45-fit__icon">&#10005;</span><span><b>Doesn&rsquo;t fit your ' + esc(car.short) + '.</b> ' + (f.listed.length ? 'Listed for ' + esc(f.listed.join(', ')) + '. ' : '') + '<a href="' + car.url + '">Shop ' + esc(car.short) + ' parts &rarr;</a></span>'; }
      else { cls = 'warn'; html = '<span class="t45-fit__icon">!</span><span><b>Fitment not listed for this part.</b> Email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> with your ' + esc(car.short) + ' and we&rsquo;ll confirm before you buy.</span>'; }
      html += '<button type="button" class="t45-fit__change" data-garage-open>Change car</button>';
    }
    box.className = 't45-fit t45-fit--' + cls;
    box.innerHTML = html;
  }

  /* ---------- garage bar ---------- */
  function carForPage() {
    var p = location.pathname.replace(/\/$/, '').toLowerCase();
    for (var i = 0; i < CARS.length; i++) { if (p === CARS[i].url || p.indexOf(CARS[i].url + '/') === 0) return CARS[i]; }
    return null;
  }
  function renderBar() {
    var bar = document.getElementById('t45-garage-bar');
    if (!bar) return;
    var v = load(), here = carForPage(), html;
    if (v) {
      var car = carById(v.id);
      html = '<span class="t45-gb__lbl">My car</span><a class="t45-gb__car" href="' + car.url + '">' + esc(carName(v)) + '</a>'
        + '<a class="t45-gb__go" href="' + car.url + '">Shop parts &rarr;</a>'
        + '<button type="button" class="t45-gb__btn" data-garage-open>Change</button>';
    } else if (here) {
      html = '<span class="t45-gb__lbl">Own a ' + esc(here.short) + '?</span>'
        + '<button type="button" class="t45-gb__btn t45-gb__btn--hot" data-garage-open data-garage-pick="' + here.id + '">Save it as my car</button>'
        + '<span class="t45-gb__hint">We&rsquo;ll check fitment on every part.</span>';
    } else {
      html = '<span class="t45-gb__lbl">My garage</span>'
        + '<button type="button" class="t45-gb__btn t45-gb__btn--hot" data-garage-open>Add your car</button>'
        + '<span class="t45-gb__hint">See what fits on every part.</span>';
    }
    bar.innerHTML = html;
  }

  /* ---------- picker dialog ---------- */
  var dlg;
  function buildDialog() {
    dlg = document.createElement('div');
    dlg.className = 't45-gd';
    dlg.hidden = true;
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 't45-gd-title');
    var opts = CARS.map(function (c) { return '<option value="' + c.id + '">' + esc(c.label) + '</option>'; }).join('');
    dlg.innerHTML = '<div class="t45-gd__panel">'
      + '<button type="button" class="t45-gd__x" aria-label="Close">&times;</button>'
      + '<div class="t45-gd__eye">My Garage</div>'
      + '<h2 id="t45-gd-title" class="t45-gd__title">Add your car</h2>'
      + '<p class="t45-gd__sub">We save it on this device and check fitment on every part you look at.</p>'
      + '<label class="t45-gd__f" for="t45-gd-car">Vehicle<select id="t45-gd-car"><option value="">Select your car</option>' + opts + '</select></label>'
      + '<label class="t45-gd__f" for="t45-gd-year">Year<select id="t45-gd-year" disabled><option value="">Select year</option></select></label>'
      + '<button type="button" class="t45-gd__save" disabled>Save my car</button>'
      + '<button type="button" class="t45-gd__rm">Remove saved car</button>'
      + '<p class="t45-gd__miss">Car not listed? Email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> and we&rsquo;ll check fitment for you.</p>'
      + '</div>';
    document.body.appendChild(dlg);
    var sc = dlg.querySelector('#t45-gd-car'), sy = dlg.querySelector('#t45-gd-year'), sv = dlg.querySelector('.t45-gd__save');
    function fillYears(selected) {
      var c = carById(sc.value);
      sy.innerHTML = '<option value="">Select year</option>';
      sy.disabled = !c;
      if (c) { for (var y = c.to; y >= c.from; y--) { sy.insertAdjacentHTML('beforeend', '<option value="' + y + '"' + (selected === y ? ' selected' : '') + '>' + y + '</option>'); } }
      sv.disabled = !(sc.value && sy.value);
    }
    sc.addEventListener('change', function () { fillYears(null); });
    sy.addEventListener('change', function () { sv.disabled = !(sc.value && sy.value); });
    sv.addEventListener('click', function () { save(sc.value, sy.value); close(); });
    dlg.querySelector('.t45-gd__rm').addEventListener('click', function () { clear(); close(); });
    dlg.querySelector('.t45-gd__x').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dlg.hidden) close(); });
    dlg._fill = fillYears;
  }
  var lastFocus;
  function open(pick) {
    if (!dlg) buildDialog();
    var v = load(), sc = dlg.querySelector('#t45-gd-car');
    sc.value = pick || (v ? v.id : '');
    dlg._fill(v && v.id === sc.value ? v.year : null);
    dlg.querySelector('.t45-gd__rm').hidden = !v;
    lastFocus = document.activeElement;
    dlg.hidden = false;
    document.documentElement.classList.add('t45-gd-open');
    sc.focus();
  }
  function close() {
    if (!dlg) return;
    dlg.hidden = true;
    document.documentElement.classList.remove('t45-gd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-garage-open]') : null;
    if (t) { e.preventDefault(); open(t.getAttribute('data-garage-pick')); return; }
    /* homepage "Find Parts" selector: remember the car the shopper picked */
    var go = e.target.closest ? e.target.closest('#ymmGo') : null;
    if (go && window.YMM_CONFIG) {
      try {
        var mk = document.getElementById('ymmMake').value, mi = parseInt(document.getElementById('ymmModel').value, 10);
        var yr = document.getElementById('ymmYear').value, make = null;
        window.YMM_CONFIG.makes.forEach(function (m) { if (m.slug === mk) make = m; });
        var mod = make && make.models[mi];
        if (mod && YMM_MAP[mod.chassis]) save(YMM_MAP[mod.chassis], yr);
      } catch (err) {}
    }
  }, true);

  function render() { renderBar(); renderFit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  window.T45Garage = { open: open, get: load, clear: clear };
})();